import { render } from "./AddressTokensTable.vue?vue&type=template&id=7ef7adb0"
import script from "./AddressTokensTable.vue?vue&type=script&lang=js"
export * from "./AddressTokensTable.vue?vue&type=script&lang=js"

import "./AddressTokensTable.vue?vue&type=style&index=0&id=7ef7adb0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__